"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerResource = void 0;
const vue_1 = require("vue");
const constants_1 = require("../../constants");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
exports.PlayerResource = vue_1.default.component('player-resource', {
    props: {
        type: {
            type: String,
        },
        canUseHeatAsMegaCredits: {
            type: Boolean || undefined,
        },
        count: {
            type: Number,
        },
        production: {
            type: Number,
        },
        plantsAreProtected: {
            type: Boolean || undefined,
        },
        plantsNeededForGreenery: {
            type: Number || undefined,
        },
        steelValue: {
            type: Number,
        },
        titaniumValue: {
            type: Number,
        },
        turmoil: {
            type: Object || undefined,
        },
        corporationCards: {
            type: Array,
        },
    },
    data: function () {
        return {};
    },
    methods: {
        mainCSS: function () {
            return 'resource_item--' + this.type;
        },
        iconCSS: function () {
            return 'resource_icon--' + this.type;
        },
        productionSign: function () {
            if (this.production > 0)
                return '+';
            return '';
        },
        displayPlantsProtectedIcon: function () {
            return this.type === Resources_1.Resources.PLANTS && this.plantsAreProtected;
        },
        showResourceValue: function () {
            switch (this.type) {
                case Resources_1.Resources.STEEL:
                    return true;
                case Resources_1.Resources.TITANIUM:
                    return true;
                case Resources_1.Resources.HEAT:
                    return this.canUseHeatAsMegaCredits;
                default:
                    return false;
            }
        },
        getResourceValue: function () {
            if (this.type === Resources_1.Resources.STEEL) {
                return `${this.steelValue}`;
            }
            else if (this.type === Resources_1.Resources.TITANIUM) {
                return `${this.titaniumValue}`;
            }
            else if (this.type === Resources_1.Resources.HEAT && this.canUseHeatAsMegaCredits) {
                return '1';
            }
            else {
                return '';
            }
        },
        getClassForResourceCount: function (count) {
            if (this.type === Resources_1.Resources.PLANTS && this.plantsNeededForGreenery !== undefined && count >= this.plantsNeededForGreenery) {
                return 'resource_item_stock_count resource-count-green-text';
            }
            if (this.type === Resources_1.Resources.HEAT && this.corporationCards.length > 0) {
                let totalHeat = count;
                const stormcraft = this.corporationCards.find((corp) => corp.name === CardName_1.CardName.STORMCRAFT_INCORPORATED);
                if (stormcraft !== undefined && stormcraft.resources !== undefined) {
                    totalHeat += stormcraft.resources * 2;
                }
                if (totalHeat >= constants_1.HEAT_FOR_TEMPERATURE)
                    return 'resource_item_stock_count resource-count-orange-text';
            }
            return 'resource_item_stock_count';
        }
    },
    template: `
        <div class="resource_item" :class="mainCSS()">
            <div class="resource_item_stock">
                <i class="resource_icon" :class="iconCSS()"></i>
                <div :class="getClassForResourceCount(count)">{{ count }}</div>
            </div>
            <div class="resource_item_prod">
                <span class="resource_item_prod_count">{{ productionSign() }}{{ production }}</span>
                <div v-if="displayPlantsProtectedIcon()" class="shield_icon"></div>
                <div v-if="showResourceValue()" class="resource_icon--metalbonus">{{ getResourceValue() }}</div>
            </div>
        </div>
    `,
});
//# sourceMappingURL=PlayerResource.js.map